import React, { useEffect, useMemo, useState } from "react";
import { useRecoilState } from "recoil";
import { youtubeInfoFilterState } from "../../../../pages/Party/YoutubeMatchingInfo";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import Flex from "../../../DefaultStyles/Flex";
import DropDown from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import { PartyInfoFilterContainer } from "../PartyInfo/PartyInfoFilter";
import CalendarLineBtn from "../../../Button/CalendarLineBtn";
import CalendarModal from "../../../Modal/CalendarModal";
import { LineBoxContainer } from "../../../../pages/UserLog/UserLog";
import { CalendarLine } from "../ChatInfo/ChatSearch/RecentChat";

interface YoutubeMatchingInfoFilterProps {
  pageResetEvent: () => void;
  excludeCompletedStatus?: boolean;
  isCompletedTab?: boolean;
}

const searchFilterTypeOption = [
  { value: "uid", label: "UID" },
//   { value: "partyid", label: "PID" },
//   { value: "nickname", label: "닉네임" },
//   { value: "admin", label: "관리자 이름" },
];

const gptSoloStatusOption = [
  { value: "1", label: "접수 예정" },
  { value: "2", label: "접수중" },
  { value: "3", label: "처리 완료" },
  { value: "4", label: "계정정보 수정 필요" },
  // { value: "5", label: "백업코드 수정 필요" },
  { value: "6", label: "접수 취소" },
  { value: "7", label: "보류(추후 처리)" },
];

const dateOption = [
  { value: "1", label: "최초 등록일" },
  { value: "2", label: "최종 수정일" },
];

export default function GptSoloMatchingInfoFilter({
  pageResetEvent,
  excludeCompletedStatus,
  isCompletedTab,
}: YoutubeMatchingInfoFilterProps) {
  const [filter, setFilter] = useRecoilState(youtubeInfoFilterState);
  const statusOptionList = useMemo(
    () =>
      isCompletedTab
        ? gptSoloStatusOption.filter((option) => option.value === "3")
        : excludeCompletedStatus
          ? gptSoloStatusOption.filter((option) => option.value !== "3")
          : gptSoloStatusOption,
    [excludeCompletedStatus, isCompletedTab],
  );

  const [filterType, setFilterType] = useState({
    value: filter?.searchType !== "" ? filter?.searchType : "",
    label:
      filter?.searchType !== ""
        ? searchFilterTypeOption?.find((f) => f.value === filter?.searchType)
            ?.label
        : "선택",
  });

  const [searchValue, setSearchValue] = useState<string | undefined>(
    filter?.searchValue !== "" ? filter?.searchValue : "",
  );

  const [status, setStatus] = useState({
    value: isCompletedTab
      ? "3"
      : filter?.stateValue !== ""
        ? filter?.stateValue
        : "",
    label:
      isCompletedTab
        ? "처리 완료"
        : filter?.stateValue !== ""
          ? statusOptionList?.find((m) => m.value === filter?.stateValue)
              ?.label ?? "접수 상태 선택"
          : "접수 상태 선택",
  });

  useEffect(() => {
    if (isCompletedTab) {
      setStatus({
        value: "3",
        label: "처리 완료",
      });
      return;
    }

    if (excludeCompletedStatus && filter?.stateValue === "3") {
      setStatus({
        value: "",
        label: "접수 상태 선택",
      });
      return;
    }

    const selectedStatus = statusOptionList.find(
      (option) => option.value === filter?.stateValue,
    );
    setStatus({
      value: selectedStatus?.value ?? "",
      label: selectedStatus?.label ?? "접수 상태 선택",
    });
  }, [
    excludeCompletedStatus,
    filter?.stateValue,
    isCompletedTab,
    statusOptionList,
  ]);

  const [dateType, setDateType] = useState({
    value: filter?.dateType !== "" ? filter?.dateType : "",
    label:
      filter?.dateType !== ""
        ? dateOption?.find((d) => d.value === filter?.dateType)?.label
        : "등록/수정일 선택",
  });

  const [startDate, setStartDate] = useState(
    filter?.startdate !== "" ? filter?.startdate : "날짜 선택",
  );
  const [startDateClick, setStartDateClick] = useState(false);

  const [endDate, setEndDate] = useState(
    filter?.enddate !== "" ? filter?.enddate : "날짜 선택",
  );
  const [endDateClick, setEndDateClick] = useState(false);

  return (
    <>
      <PartyInfoFilterContainer>
        <Flex gapSize={10}>
          <DropDown
            boxWidth={160}
            optionList={searchFilterTypeOption}
            dropdownValue={filterType}
            setDropDownValue={setFilterType}
          />

          <Search
            placeholder="입력"
            setSearchValue={(value) => {
              setSearchValue(value);
              if (value && String(value).length > 0) {
                setFilter((prev) => ({
                  ...prev,
                  searchType: filterType?.value,
                  searchValue: `${value}`,
                }));
              }
            }}
            defaultValue={
              filter?.searchValue !== "" ? filter?.searchValue : undefined
            }
            pageResetEvent={() => pageResetEvent()}
            isDisabled={filterType?.value === ""}
            inputType={
              filterType?.value === "uid" || filterType?.value === "partyid"
                ? "number"
                : "text"
            }
          />
        </Flex>

        <Flex gapSize={10}>
          <FilterIcon />

          {/* 접수 상태 선택 */}
          <DropDown
            boxWidth={180}
            dropdownValue={status}
            setDropDownValue={setStatus}
            optionList={statusOptionList}
            isDisabled={isCompletedTab}
          />

          {/* 등록/수정일 선택 */}
          {/* <DropDown
            boxWidth={160}
            dropdownValue={dateType}
            setDropDownValue={setDateType}
            optionList={dateOption}
          /> */}

          {/* 날짜 선택 */}
          {/* <>
            <LineBoxContainer>
              <CalendarLineBtn
                onClickEvent={() => setStartDateClick(true)}
                value={startDate}
                initValue={"날짜 선택"}
                minWidth={155}
                disabled={dateType?.value === ""}
              />

              {startDateClick && (
                <CalendarModal
                  closeEvent={() => setStartDateClick(false)}
                  changeEvent={(date: string) => setStartDate(date)}
                  isFutureDisable={true}
                />
              )}
            </LineBoxContainer>

            <CalendarLine />

            <LineBoxContainer>
              <CalendarLineBtn
                onClickEvent={() => setEndDateClick(true)}
                value={endDate}
                initValue={"날짜 선택"}
                minWidth={155}
                disabled={startDate?.includes("선택")}
              />

              {endDateClick && (
                <CalendarModal
                  closeEvent={() => setEndDateClick(false)}
                  changeEvent={(date: string) => setEndDate(date)}
                  dateValue={startDate}
                  isAfterStartDate={true}
                />
              )}
            </LineBoxContainer>
          </> */}

          <ConfirmBtn
            btnText="적용"
            btnColor="mint"
            btnHeight={38}
            isDisabled={
              isCompletedTab ||
              (status?.value === "" &&
                (startDate?.includes("선택") || endDate?.includes("선택")))
            }
            btnClickEvent={() => {
              pageResetEvent();
              setFilter((prev) => ({
                ...prev,
                stateValue: status?.value,
                dateType: dateType?.value,
                startdate: startDate,
                enddate: endDate,
              }));
            }}
          />

          <LineBtn
            btnText="초기화"
            btnColor="mint"
            icon="refresh"
            btnHeight={38}
            disabled={
              isCompletedTab ||
              (status?.value === "" &&
                dateType?.value === "" &&
                startDate?.includes("선택") &&
                endDate?.includes("선택"))
            }
            btnClickEvent={() => {
              setStartDate("날짜 선택");
              setEndDate("날짜 선택");

              setStatus({
                value: "",
                label: "접수 상태 선택",
              });

              setDateType({
                value: "",
                label: "등록/수정일 선택",
              });

              setFilter((prev) => ({
                ...prev,
                stateValue: "",
                dateType: "",
                startdate: "",
                enddate: "",
              }));
            }}
          />
        </Flex>
      </PartyInfoFilterContainer>
    </>
  );
}
